import { GDSTheme } from '@leagueplatform/genesis-core';
import { spacing } from './spacing';
import { colors } from './colors/colors';
import { borderRadii } from './borderRadii';
import { shadows } from './shadows';
import { borderWidths } from './borderWidths';
import { typography } from './typography';
import { rem } from './rem';
import { fonts } from './fonts';
import { zIndices } from './zIndices';
import { transitions } from './transitions';

export const leagueTheme: GDSTheme = {
  spacing,
  colors,
  borderRadii,
  borderWidths,
  shadows,
  typography,
  fonts,
  zIndices,
  transitions,
  rem,
};

export { spacing, colors, shadows, fonts };
